import React, { useState } from 'react';
import { postReport } from '../network/post_report';

// 신고 사유 목록
const REPORT_REASONS = [
    { value: '', label: '신고 사유를 선택해주세요' },
    { value: '부적절한 사진', label: '부적절한 사진' },
    { value: '욕설 및 비방', label: '욕설 및 비방' },
    { value: '상업적 이용', label: '상업적 이용' },
    { value: '도용', label: '도용' },
    { value: '기타', label: '기타' },
];

/**
 * 신고 기능을 위한 재사용 가능한 모달 컴포넌트입니다.
 * * @param {boolean} isOpen - 모달 열림/닫힘 상태
 * @param {function} onClose - 모달을 닫는 함수
 * @param {function} onConfirm - 신고 사유와 함께 신고 처리를 진행하는 함수
 */
function ReportModal({ isOpen, onClose, onConfirm }) {
    const [selectedReason, setSelectedReason] = useState('');

    if (!isOpen) {
        return null;
    }

    // 드롭다운 변경 핸들러
    const handleSelectChange = (e) => {
        setSelectedReason(e.target.value);
    };

    // '확인' 버튼 클릭 핸들러
    const handleConfirm = () => {
        if (!selectedReason) {
            alert('신고 사유를 선택해주세요.');
            return;
        }
        
        // ⭐️ 신고 처리 함수 호출
        onConfirm(selectedReason);
        
        // 상태 초기화 및 모달 닫기
        setSelectedReason('');
        onClose();
    };
    
    // '취소' (모달 닫기) 핸들러
    const handleCancel = () => {
        setSelectedReason('');
        onClose();
    }

    return (
        // ⭐️ 배경 (Backdrop): 클릭 시 모달 닫기 기능 추가
        <div style={modalStyles.backdrop} onClick={handleCancel}>
            {/* ⭐️ 모달 내용 (클릭 이벤트 전파 방지) */}
            <div style={modalStyles.content} onClick={(e) => e.stopPropagation()}>
                
                {/* 제목 */}
                <h3 style={modalStyles.title}>신고하기</h3>

                {/* 신고 사유 드롭다운 */}
                <select 
                    value={selectedReason} 
                    onChange={handleSelectChange}
                    style={modalStyles.select}
                >
                    {REPORT_REASONS.map((option) => (
                        <option key={option.value} value={option.value} disabled={option.value === ''}>
                            {option.label}
                        </option>
                    ))}
                </select>
                
                {/* 버튼 그룹 */}
                <div style={modalStyles.buttonGroup}>
                    <button 
                        onClick={handleCancel}
                        style={modalStyles.cancelButton}
                    >
                        취소
                    </button>
                    <button 
                        onClick={handleConfirm}
                        style={modalStyles.confirmButton}
                        disabled={!selectedReason} // 사유 선택 전에는 비활성화
                    >
                        확인
                    </button>
                </div>
            </div>
        </div>
    );
}

const modalStyles = {
    // 배경
    backdrop: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000,
    },
    // 모달 박스
    content: {
        backgroundColor: 'white',
        borderRadius: '10px',
        width: '90%',
        maxWidth: '400px',
        paddingTop: '20px',
        overflow: 'hidden',
        boxShadow: '0 5px 15px rgba(0, 0, 0, 0.3)',
    },
    title: {
        fontSize: '18px',
        fontWeight: 'bold',
        textAlign: 'center',
        marginBottom: '20px',
    },
    select: {
        width: 'calc(100% - 40px)', // 좌우 패딩 고려
        margin: '0 20px 20px 20px',
        padding: '12px',
        borderRadius: '5px',
        border: '1px solid #ddd',
        fontSize: '15px',
        appearance: 'none', // 기본 화살표 제거 (커스텀 스타일링을 위해)
        backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' fill='%23555'%3E%3Cpath fill-rule='evenodd' d='M5.23 7.21a.75.75 0 011.06.02L10 10.97l3.71-3.74a.75.75 0 111.06 1.06l-4.25 4.25a.75.75 0 01-1.06 0L5.23 8.27a.75.75 0 01.02-1.06z' clip-rule='evenodd' /%3E%3C/svg%3E")`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'right 15px center',
        backgroundSize: '16px',
    },
    buttonGroup: {
        display: 'flex',
        borderTop: '1px solid #eee',
    },
    baseButton: {
        flex: 1,
        padding: '15px 10px',
        fontSize: '16px',
        fontWeight: 'bold',
        border: 'none',
        cursor: 'pointer',
        backgroundColor: 'white',
        transition: 'background-color 0.1s',
    },
    cancelButton: {
        flex: 1,
        padding: '15px 10px',
        fontSize: '16px',
        fontWeight: 'bold',
        border: 'none',
        cursor: 'pointer',
        backgroundColor: 'white',
        transition: 'background-color 0.1s',
        color: '#888',
        borderRight: '1px solid #eee',
    },
    confirmButton: {
        flex: 1,
        padding: '15px 10px',
        fontSize: '16px',
        fontWeight: 'bold',
        border: 'none',
        cursor: 'pointer',
        backgroundColor: 'white',
        transition: 'background-color 0.1s',
        color: '#ff4d4f', // 모디의 주요 색상(빨간색) 가정
    },
};

export default ReportModal;